import { render, staticRenderFns } from "./ShiftWirelessLegacy.vue?vue&type=template&id=04db5fae&scoped=true"
import script from "./ShiftWirelessLegacy.vue?vue&type=script&lang=js"
export * from "./ShiftWirelessLegacy.vue?vue&type=script&lang=js"
import style0 from "./ShiftWirelessLegacy.vue?vue&type=style&index=0&id=04db5fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db5fae",
  null
  
)

export default component.exports